export const getDataURL = (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const resizeImageFile = (file: File, options: { maxWidthOrHeight: number }): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      const { width, height } = img;
      const maxSize = options.maxWidthOrHeight;
      let newWidth = width;
      let newHeight = height;
      
      if (width > height && width > maxSize) {
        newHeight = (height * maxSize) / width;
        newWidth = maxSize;
      } else if (height > maxSize) {
        newWidth = (width * maxSize) / height;
        newHeight = maxSize;
      }
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);
      
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to resize image'));
        }
      });
    };
    
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};